import { render, staticRenderFns } from "./CartItemAttachments.vue?vue&type=template&id=effbe90e&scoped=true&"
import script from "./CartItemAttachments.vue?vue&type=script&lang=js&"
export * from "./CartItemAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CartItemAttachments.vue?vue&type=style&index=0&id=effbe90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effbe90e",
  null
  
)

export default component.exports